module.exports = __webpack_public_path__ + "media/country_flags/bn-ba4ab5f0.png";